export const PRODUCT_LIST_PAGE_SIZE = [50, 100, 150, 200, 300];
export const DEFAULT_PRODUCT_LIST_PAGE_SIZE = PRODUCT_LIST_PAGE_SIZE[0];
